module.exports = __webpack_public_path__ + "img/image24.02778cb7.png";